/**
* @ngdoc directive
* @name State Picker
*
* @description
  US States selector.
  Note. Requires authentication for demo
*
* @scope
* @param {Object} selectedState - selected state
* @param {Number} stateId - id of currently selected state
* @param {Object} contact - state holder
*
* @example
  <div ng-init='selecedState={};contact={};'>
    <state-picker
      state-id="1"
      selected-state="selectedState"
      contact="company.contact">
    </state-picker>
  </div>
*/

(function () {
  statePicker.$inject = ["apiService", "PATH", "localStorageService", "$location"];
  app.directive('statePicker', statePicker);

  function statePicker(apiService, PATH, localStorageService, $location) {
    controller.$inject = ["$scope"];
    return {
      scope: {
        selectedState: '=',
        stateId: '=',
        contact: '='
      },
      restrict: 'E',
      templateUrl: PATH.components + 'statePicker/statepicker.html',
      controller: controller
    };

    function controller($scope) {
      var isDocsPage = $location.absUrl().indexOf('documentation') > -1;
      var user = localStorageService.get('userInfo');
      var userWasAuthenticated = user && user !== 'null';
      if (!userWasAuthenticated && isDocsPage) {
        return;
      }

      apiService.getSome('usstates')
        .then(function (res) {
          $scope.states = res.data;
          findState($scope.stateId);
        });

      $scope.$watch('stateId', function (value) {
        if (value) findState(value);
      });

      function findState(id) {
        var state = _.find($scope.states, { id: id });
        _.assign($scope.selectedState, state);
      }

      $scope.$watch('contact.stateName', function (newValue, oldValue) {
        if (newValue === oldValue) return;

        var state = _.find($scope.states, { caption: newValue });
        _.assign($scope.selectedState, state);
        $scope.stateId = state && state.id;
      });
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/statePicker/statePickerDirective.js